import { RacemapColors } from '@racemap/utilities/consts/common';

interface Props {
  lat: number;
  lng: number;
  zoom?: number;
  decimals?: number;
}

function createOpenStreetMapLink(lat: number, lng: number, zoom: number): string {
  return `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=${zoom}/${lat}/${lng}`;
}

export function LatLngExternalLink({
  lat,
  lng,
  zoom = 17,
  decimals = 3,
}: Props): React.ReactElement {
  const href = createOpenStreetMapLink(lat, lng, zoom);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title="Open exact location in OpenStreetMap"
      style={{ color: RacemapColors.PaleBlue }}
    >
      {`${lat.toFixed(decimals)}|${lng.toFixed(decimals)}`}
    </a>
  );
}
